/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgToolbarChevronUp: React.FC<React.SVGAttributes<SVGElement>> = (
    props
) => (
    <svg viewBox="0 0 20 20" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M15.59 13.09a.836.836 0 01-1.18 0L10 8.68l-4.41 4.41a.836.836 0 01-1.18 0 .836.836 0 010-1.18l4.884-4.88a1 1 0 011.414 0l4.882 4.88a.832.832 0 010 1.178z"
            />
        </g>
    </svg>
);
